export default "/50f517735fec46580f19aae3e56e9fe21614ea75/dfffdcc654f425d556d7485c2bf841db.svg";